import React from "react";
import { Card } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FlightRiskPanel from "Pages/EmployeeDashboard/FlightRisk/FlightRiskPanel";

// Admin (company-wide) Flight Risk / Retention Insights, optional dept filter.
const AdminFlightRisk = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <Card
      title="Flight Risk / Retention Insights"
      className="card-professional"
      style={{ margin: 16 }}
    >
      <FlightRiskPanel mode="admin" />
    </Card>
  </DashboardLayout>
);

export default AdminFlightRisk;
